import React from 'react';
import { Col as AntRow } from '@vertem-core/vertice-ds';

const Col: React.FC<any> = (props) => <AntRow {...props} />;

export default Col;
